import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { addUserStreamsSpeedDial, deleteUser, editUserStreamsSettings } from "../../../apiclients/streamsapi_bridge.js";
import { useForm } from "react-hook-form";
import { validatePhoneNumber, validatePhoneNumberExt, validateSpeeddialNum } from "../phonenumbers/AddRemoveNumbers.js";

const AddSpeedDials = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const [speedid, setSpeedId] = useState(0);
  const [resetDefault, setResetDefault] = useState({});
  // const [isloading, setIsloading] = useState(false);

  const { register, setValue, getValues, watch, setError, formState: { isDirty, dirtyFields, errors }, handleSubmit, reset } = useForm({
    defaultValues: {
      name: "",
      ph_number: "",
      speed_dial_number: "",

    }
  })

  useEffect(() => {
    if (Object.keys(props.editSpeedObj).length > 0) {
      setSpeedId(props?.editSpeedObj?.speed_dial_id ?? 0);
      reset({
        name: props?.editSpeedObj?.name,
        ph_number: props?.editSpeedObj?.ph_number,
        speed_dial_number: props?.editSpeedObj?.speed_dial_number,
      });
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }

  }, [props.editSpeedObj]);

  const onSubmit = async (data) => {
    if (isDirty) {
      if (isEdit) {
        let update = {
          reqid: 51,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          agentid: props.useragent,
          streams_speed_dials: {
            update_speed_dial: {},
          }
        }
        const newObj = {};
        for (const field of Object.keys(dirtyFields)) {
          newObj[field] = data[field];
        }
        newObj.speed_dial_id = speedid;
        update.streams_speed_dials.update_speed_dial = newObj;
        props.setIsloading(true);
        console.log("Edit speed Dial :::::: " + JSON.stringify(update));
        let saverep = await editUserStreamsSettings(update);
        let saverepeMsg = await saverep.json();
        console.log("Reponse for update  speed dial ::::: " + JSON.stringify(saverepeMsg));
        setTimeout(() => {
          props.setIsloading(false);
        }, 1000);
        if (saverepeMsg.status && saverepeMsg.status === "success") {
          props.setSuccessMessage(saverepeMsg.message);
          const modifiedObj = {
            speed_dial_id: speedid,
            name: data.name,
            ph_number: data.ph_number,
            speed_dial_number: data.speed_dial_number,
          }
          props.modifiedObj(modifiedObj);
          props.onClose();

        } else {
          if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
              let fieldName = "";
              if (err.param_name.toString().includes('.')) {
                const splitArr = err.param_name.toString().split('.');
                fieldName = splitArr[splitArr.length - 1];

              } else {
                fieldName = err.param_name.toString();

              }
              setError(fieldName, {
                type: "server",
                message: err.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${fieldName}"]`
              );
              if (fieldElement) {
                fieldElement.focus();

              }
            });
          }

        }

      }
      else {
        let update = {
          reqid: 63,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          agentid: props.useragent,
          add_speed_dial: {
            name: data.name,
            ph_number: data.ph_number,
            speed_dial_number: data.speed_dial_number,

          }

        }

        console.log(" create speed dial " + JSON.stringify(update))
        let saverep = await addUserStreamsSpeedDial(update);

        let saverepeMsg = await saverep.json();
        console.log("reposnse of add speed dial:::::::" + JSON.stringify(saverepeMsg));

        if (saverepeMsg.status && saverepeMsg.status == "success") {
          const speeddialid = saverepeMsg.added_speeddial ?? "";

          const modifiedObj = {
            speed_dial_id: speeddialid,
            name: data.name,
            ph_number: data.ph_number,
            speed_dial_number: data.speed_dial_number,
          }
          props.setSuccessMessage(saverepeMsg.message);
          props.modifiedObj(modifiedObj);
          props.onClose();

        } else {
          if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
              let fieldName = "";
              if (err.param_name.toString().includes('.')) {
                const splitArr = err.param_name.toString().split('.');
                fieldName = splitArr[splitArr.length - 1];

              } else {
                fieldName = err.param_name.toString();

              }
              setError(fieldName, {
                type: "server",
                message: err.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${fieldName}"]`
              );
              if (fieldElement) {
                fieldElement.focus();

              }
            });
          }
        }
      }
    }

  }

  return (
    <>
      <form>
        <div>
          <div className="tel-numbers">
            <strong>{t("AddSpeedDialNo")}</strong>
          </div>
          <div className="form pt-1">
            <input type="text" className="w-100"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              {...register("speed_dial_number", { setValueAs: (value) => Number(value), required: "Dial Number should not be empty",validate: validateSpeeddialNum })}
            />
            {errors.speed_dial_number && (
              <p className="text-danger">{errors.speed_dial_number.message}</p>
            )}
          </div>
          <div className="tel-numbers mt-2">
            <strong>{t("name")}</strong>
          </div>
          <div className="form mt-2">
            <input type="text"
            maxLength={64}
              className="w-100"
              {...register("name", { setValueAs: (v) => v?.trim(),  required: "Name should not be empty" })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
          <div className="tel-numbers mt-2">
            <strong>{t("Number")}</strong>
          </div>
          <div className="form pt-1">
            <input type="text" className="w-100"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              {...register("ph_number", { required: "Number should not be empty", validate: validatePhoneNumberExt })}
            />
            {errors.ph_number && (
              <p className="text-danger">{errors.ph_number.message}</p>
            )}
          </div>
        </div>
      </form>

      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onSubmit)() }}>
          {props.isEdit ? t("save") : t("add")}</button>
      </div>

      {/* <MDBModalFooter>
        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)();
        }}>{isEdit ? t("save") : t("add")}</MDBBtn>
      </MDBModalFooter> */}
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}

    </>
  );
});

export default AddSpeedDials;
